<template>
  <tile class="opc-zp-aic opc-zp-aic__trial">
    <foldable v-model="isExpanded" :title="title">
      <template #head>
        <CardHeader :logo="logo" :title="title">
          <template #head-right-content>
            <zm-button v-if="isExpanded" data-testid="checkout-button-zp-aic-trial-plan-details" type="text" @click="onPlanDetailsClick">
              {{ $t('billing.plan_details') }}
            </zm-button>
          </template>

          <div class="opc-zp-aic__trial-desc" v-if="isExpanded">
            <p class="opc-zp-aic__desc-text">
              <img src="@/assets/check_blue.svg" alt="Include" />
              {{ $t('billing.pbx.zp_aic.free_trial.benefit_1', { days: freeTrialDays }) }}
            </p>
            <p class="opc-zp-aic__desc-text">
              <img src="@/assets/check_blue.svg" alt="Include" />
              {{ $t('billing.pbx.zp_aic.free_trial.benefit_2') }}
            </p>
            <p class="opc-zp-aic__desc-text">
              <img src="@/assets/check_blue.svg" alt="Include" />
              {{ $t('billing.pbx.zp_aic.free_trial.benefit_3') }}
            </p>
          </div>
        </CardHeader>
      </template>

      <div class="divide-line"></div>
      <div class="opc-zp-aic__main">
        <zm-form>
          <zm-form-item>
            <p class="label-title-1">{{ $t('billing.pbx.zp_aic.free_trial.details_title') }}</p>
            <p class="opc-zp-aic__license-desc">
              {{ $t('billing.pbx.zp_aic.free_trial.details_placeholder', { days: freeTrialDays, minutes: trialCredit }) }}
            </p>

            <zm-radio-group
              class="opc-card-radio billing-cycle-radios"
              :aria-label="`Select ${PLAN_DISPLAY_NAME_FREE_TRIAL} plan`"
              v-model="selectedPlanCode"
              @update:model-value="onPlanSelect"
            >
              <zm-radio
                v-if="freeTrialPaygPlan"
                :key="freeTrialPaygPlan.plan_code"
                :label="freeTrialPaygPlan.plan_code"
                data-testid="checkout-radio-zp-aic-trial-payg"
              >
                <div class="opc-zp-aic__trial-card-content">
                  <p class="opc-zp-aic__trial-period-title">
                    {{ $t('billing.pay_you_go') }}
                    <span class="opc-zp-aic__trial-highlight">
                      {{ $t('billing.pbx.free_trial.x_day_trial_desc', [freeTrialDays]) }}
                    </span>
                  </p>
                  <div class="opc-zp-aic__trial-pricing">
                    <span class="opc-zp-aic__trial-price-current" :aria-label="`current price ${$money(0)}`">{{ $money(0) }}</span>
                  </div>
                  <p class="opc-zp-aic__trial-billing-desc" v-html="$t('billing.pbx.zp_aic.then_billed_monthly', { price: unitPriceText })"></p>
                </div>
              </zm-radio>
            </zm-radio-group>
          </zm-form-item>
        </zm-form>
      </div>
    </foldable>

  </tile>
</template>
<script>
import Foldable from '@/components/foldable.vue';
import Tile from '@/components/tile.vue';
import CardHeader from '@/components/plan-card-header.vue';
import { mapGetters, mapMutations } from 'vuex';
import { planTypes } from '@/common/constants';
import { plansof } from '@/utils/chain';
import planMixin from '@/plans/ZOOM_PHONE$AICONCIERGE/mixin';
import planDetailsDialogMixin from '@/plans/ZOOM_PHONE$AICONCIERGE/dialog/plan-details';
import { PLAN_DISPLAY_NAME_FREE_TRIAL } from '@/plans/ZOOM_PHONE$AICONCIERGE/constants';

export default {
  mixins: [planMixin, planDetailsDialogMixin],
  data() {
    return {
      title: this.$t('billing.planform.title.zoom_phone_ai_concierge_ft'),
      isExpanded: true,
      selectedPlanCode: '',
    };
  },
  components: {
    Foldable,
    Tile,
    CardHeader,
  },
  computed: {
    ...mapGetters({
      'getSelectedPlans': 'getSelectedPlans',
      'planMapFlat': 'planMapFlat',
    }),
    selectedAicTrialPlan() {
      return this.getSelectedPlans.find(item => item.type === planTypes.ZOOM_PHONE$AICONCIERGE && item.isOnlineFreeTrial);
    },
    freeTrialAicPlans() {
      return plansof(this.planMapFlat)
        .type(planTypes.ZOOM_PHONE$AICONCIERGE)
        .freeTrial()
        .get();
    },
    freeTrialPaygPlan() {
      return this.freeTrialAicPlans.find((p) => p.is_payg) || this.freeTrialAicPlans[0] || null;
    },
    freeTrialDays() {
      return this.freeTrialPaygPlan?.trialDays;
    },
    trialCredit() {
      return this.freeTrialPaygPlan?.credit;
    },
    unitPriceText() {
      if (!this.freeTrialPaygPlan) return '';
      return `${this.$money(this.freeTrialPaygPlan.amount)}${this.$t('billing.common.per_minute')}`;
    },
  },
  methods: {
    ...mapMutations({
      'updateSelectPlan': 'updateSelectPlan',
    }),
    onPlanSelect(newPlanCode) {
      if (!newPlanCode) return;
      const plan = this.freeTrialAicPlans.find((p) => p.plan_code === newPlanCode);
      if (!plan) return;
      this.updateSelectPlan({
        ...plan,
        cartInfo: { selected_number: 1 },
      });
      this.$tracking.buyInteraction(
        'zoom phone add-on',
        `${PLAN_DISPLAY_NAME_FREE_TRIAL} - select - Pay as you go`
      );
    },
    onPlanDetailsClick() {
      this.showPlanDetailDialog({
        title: this.title,
        trackingPlanName: PLAN_DISPLAY_NAME_FREE_TRIAL,
        unitPriceText: this.unitPriceText,
      });
    },
  },
  watch: {
    selectedAicTrialPlan: {
      immediate: true,
      handler(plan) {
        this.selectedPlanCode = plan?.plan_code ?? this.freeTrialPaygPlan?.plan_code ?? '';
      },
    },
    isExpanded(val) {
      this.$tracking.buyInteraction(
        'product details accordion',
        `${PLAN_DISPLAY_NAME_FREE_TRIAL} - ${val ? 'expand' : 'collapse'}`
      );
    },
  },
  created() {
    if (!this.selectedAicTrialPlan && this.freeTrialPaygPlan?.plan_code) {
      this.onPlanSelect(this.freeTrialPaygPlan.plan_code);
    }
  },
};
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';

.opc-zp-aic {
  &__trial.opc-zp-aic {
    .label-title-1 {
      color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
      font-size: 16px;
      font-weight: 600;
      line-height: 20px;
      margin-bottom: 4px;
    }
  }
  &__trial-desc {
    margin: 14px 0 0 0px;
  }
  &__desc-text {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
    margin: 4px 0;
    img {
      display: inline-block;
      margin-right: 8px;
    }
  }
  &__license-desc {
    color: #666487;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    margin: 4px 0 8px;
  }
  &__trial-card-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  &__trial-period-title {
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    .opc-zp-aic__trial-highlight {
      color: #247F40;
      font-size: 16px;
      font-weight: 400;
      line-height: 20px;
    }
  }
  &__trial-pricing {
    display: flex;
    font-size: 24px;
    font-weight: 600;
    line-height: 28px;
    align-items: center;
    gap: 2px;
  }
  &__trial-price-current {
    color: #247F40;
    font-size: 24px;
    font-weight: 700;
  }
  &__trial-billing-desc {
    color: #2A2B2D;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;

    > b {
      font-weight: 600;
    }
  }
}
</style>
